import { useWhatsNewStore } from "@/stores/useWhatsNewStore";
import { APP_VERSION } from "@/shared/utils/appVersion";

const showVersion = process.env.REACT_APP_SHOW_VERSION === "true";

/** The running version; opens "What's new". */
const AppVersionBadge = ({ expanded = true }) => {
  const open = useWhatsNewStore((state) => state.open);
  if (!showVersion) return null;
  return (
    <button
      type="button"
      onClick={open}
      title="What's new"
      aria-label={`Version ${APP_VERSION}. Open what's new`}
      className={`mx-auto rounded-md px-1.5 py-0.5 font-medium text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-gray-800 dark:hover:text-gray-300 ${expanded ? "text-[10px]" : "mt-1 text-[9px]"}`}
    >
      {expanded ? `Version ${APP_VERSION}` : `v${APP_VERSION}`}
    </button>
  );
};

export default AppVersionBadge;
